'use strict';

var Notificication = {};

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 * @param {string} type - Notification type
 */
Notificication.createNotification = (message, type) => {
    $('.error-messaging').find('.alert').stop(true).remove();

    var $alert = $(`<div class="alert alert-${type} notification-alert text-center fade show" role="alert">${message}</div>`);

    $('.error-messaging').append($alert).show();
    $alert.delay(4000).fadeOut(300, function () {
        $(this).remove();
    });
};

module.exports = Notificication;
